(() => {
  const mobile = window.matchMedia('(max-width: 768px)');
  let opened = false;
  let trigger;
  const sync = () => window.$crisp.push(['do', mobile.matches && !opened ? 'chat:hide' : 'chat:show']);
  window.$crisp = window.$crisp || [];
  window.$crisp.push(['on', 'chat:opened', () => { opened = true; }]);
  window.$crisp.push(['on', 'chat:closed', () => {
    opened = false;
    sync();
    if (mobile.matches && trigger) trigger.focus();
  }]);
  mobile.addEventListener('change', sync);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-beachsim-chat]');
    if (!button) return;
    trigger = button;
    opened = true;
    window.$crisp.push(['do', 'chat:show']);
    window.$crisp.push(['do', 'chat:open']);
  });
  sync();
})();
